import { useStore } from 'zustand'
import { createStore } from 'zustand/vanilla'

import { ColorMode, DEFAULT_STATE } from '../constants'

type ColorModeState = {
  colorMode: ColorMode
  setColorMode(colorMode: ColorMode): void
}

export const colorModeStore = createStore<ColorModeState>((set) => {
  return {
    ...DEFAULT_STATE,
    setColorMode(colorMode: ColorMode) {
      set(() => ({ colorMode }))
    },
  }
})

export function useColorMode() {
  return useStore(colorModeStore, (state) => state.colorMode)
}

export function useIsDarkMode() {
  const currentColorMode = useStore(colorModeStore, (state) => state.colorMode)
  return currentColorMode === ColorMode.Dark
}
